// extracted by mini-css-extract-plugin
export default {"MainCont":"Proofing_MainCont__F9BUv","LeftCont":"Proofing_LeftCont__I1Wf8","RightCont":"Proofing_RightCont__oV2Eg"};